import CheckboxSelected from '@assets/media/checkboxSelected.svg';
import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
import { hexToRGB } from 'common/utils/helpers';

GlobalStyle.inject`
.order-selector-horizontal-container {
    .h2 {
        margin-right:${getScalablePixel(32)}px;
        text-transform: uppercase;
    }

    .order-selector-horizontal-view {
        display: flex;
        flex-direction: row;
        padding: ${getScalablePixel(8)}px 0;
        opacity: 0.7;

        &.focused {
            opacity: 1;
        }
        .separator {
            width: ${getScalablePixel(1)}px;
            height: ${getScalablePixel(9)}px;
            background: ${variables.color_grey_60};
        }

        .order-selector-horizontal-view-item-separator {
            color: ${variables.color_grey_30};
            font-size: ${getScalablePixel(46)}px;
            margin: 0 ${getScalablePixel(8)}px;
        }

        .order-selector-horizontal-view-item {
            background: ${variables.color_grey_70};
            margin: 0 ${getScalablePixel(8)}px;
            padding: ${getScalablePixel(8)}px ${getScalablePixel(16)}px;
            border-radius: ${getScalablePixel(4)}px;
            
            box-shadow: 0 0 0 ${getScalablePixel(1)}px ${variables.color_grey_50};

            &.focused {
                background: ${variables.color_grey_10} !important;
                .title {
                    color: ${variables.color_grey_90} !important;
                },
                .subtitle {
                    color: ${variables.color_grey_50} !important;
                }
            }

            &.selected {
                box-shadow: 0 0 0 ${getScalablePixel(1)}px ${variables.color_grey_20};
            }

            .checkbox {
                position: relative;
                background: url(${CheckboxSelected}) no-repeat center center, 
                    ${variables.color_grey_90};
                background-size: cover;
                width: ${getScalablePixel(24)}px;
                height: ${getScalablePixel(24)}px;
                border-radius: ${getScalablePixel(32)}px;
            }

            .title, .subtitle {
                padding: 0 ${getScalablePixel(8)}px;
            }

            .title {
                color: ${hexToRGB(variables.color_grey_10)} !important;
                font-size: ${getScalablePixel(20)}px !important;
                font-weight: 700 !important;
                text-transform: uppercase !important;
            }

            .subtitle {
                color: ${hexToRGB(variables.color_grey_45)} !important;
                font-size: ${getScalablePixel(18)}px !important;
                font-weight: 400 !important;
            }
        }
    }
}

`;
